import { Grid } from "@mui/material";

import FormOne from "./FormOne";
import FormTwo from "./FormTwo";
import EditButtons from "../../../components/EditButtons";
import { ButtonFooter, PageHeader, Paper } from "../../../components";

export default function FormDisplay({ editState, formikProps, setEditState }) {
  return (
    <Grid container spacing={4} style={{ padding: "20px" }}>
      <Grid size={12}>
        <PageHeader
          pageName={
            !formikProps.values.agencyID
              ? "Create New Agency"
              : "Agency Details"
          }
          pageHeader={
            !formikProps.values.agencyID
              ? "Provide agency information to onboard and start managing campaigns."
              : "View complete information about the agency. Edit if necessary."
          }
          buttons={[
            <EditButtons editState={editState} setEditState={setEditState} />,
          ]}
        />
      </Grid>

      <Paper>
        <FormOne formikProps={formikProps} editState={editState} />
        <FormTwo formikProps={formikProps} editState={editState} />
      </Paper>

      {editState && (
        <Grid size={12}>
          <ButtonFooter
            ID={formikProps.values.brandID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Grid>
      )}
    </Grid>
  );
}
